<div fxLayout="row" fxLayout.lt-md="column" ngClass.gt-sm="container" ngClass.lt-md="container2" fxFlex="100%">

    <div  class="fw containerIzq" >
        <div fxLayout="column">
            <h5 class="gray-9 centertext">Capacitación para empresas</h5>
            <div fxLayout="column" fxLayoutAlign="center center">
                <h6 class="gray-7 centertext">Inicia un plan de formación junto con tu equipo de trabajo </h6>
                <p class="gray-6 centertext"> Desarrolla el perfil profesional de cada miembro.</p>
            </div>
            <div fxLayout="column" fxLayoutAlign="center">
                <img [src]="capEmpresas" class="w-100" alt="">
            </div>
        </div>
    </div>

    <div  class="fw backGray2" ngClass.lt-md="containerDer2"> 
        
        <div class="form">
            <form [formGroup]="registerForm" *ngIf="enviado==false">
                <p class="">Contáctanos para obtener entrenamiento para tu equipo.</p>
                <div>
                    <label>Nombre y apellido <span class="red-5">*</span></label>
                    <input type="text" formControlName="nombres" class="fw">
                </div>
                <div class="mgt10">
                    <label>Empresa <span class="red-5">*</span></label>
                    <input type="text" formControlName="empresa" class="fw">
                </div>
                <div class="mgt10">
                    <label>Email <span class="red-5">*</span></label>
                    <input type="text" formControlName="email" class="fw">
                </div>
                <div class="mgt10">
                    <label>Telefono <span class="red-5">*</span></label>
                    <input type="text" formControlName="telefono" class="fw">
                </div>
                <div class="mgt10">
                    <label>País<span class="red-5">*</span></label>
                    <input type="text" formControlName="pais" class="fw">
                </div>

                <div class="mgt20">
                    <button class="backGray4 fw"  *ngIf="habilitarEnviar==0">Enviar</button>
                    <button class="darkButton fw" *ngIf="habilitarEnviar==1"
                        (click)="enviar()">Enviar</button>
                </div>
            </form>
            <div *ngIf="enviado">
                <p>Solicitud enviada. Un asesor se estará contactando contigo a la brevedad posible. </p>
            </div>
        </div>
    </div>

</div>



<!-- 






<section class="section-100vh " ngClass.lt-md="section-mobile-auto-height" fxLayoutAlign="center center">
    <div class="cw" fxLayout="column" fxLayoutAlign="space-between center" fxLayoutGap="2rem">

        <h5 class="gray-9 centertext">Capacitación para empresas</h5>
        <div fxLayout="column" fxLayoutAlign="center center">
            <h6 class="gray-7 centertext">Inicia un plan de formación junto con tu equipo de trabajo </h6>
            <p class="gray-6 centertext"> Desarrolla el perfil profesional de cada miembro.</p>
        </div>


        <div fxLayout="row" fxLayoutGap="2rem">
            <div fxLayout="column" fxLayoutAlign="center">
                <img [src]="capEmpresas" class="w-100" alt="">
            </div>
        </div>

        <div fxLayout="column" fxFlex="50%" fxLayoutAlign="center center">
            <div fxLayout="row" fxLayoutAlign="center">
                <mat-icon class="ftxxxl gray-4 linkIcon"> person_add</mat-icon>
            </div>
            <div class="mgb10" fxLayout="column" fxLayoutAlign="center center">

                <br>
                <p>Contactanos para obtener capacitación para tu equipo de trabajo.

            </div>
        </div>

        <div ngClass.gt-sm="w-50" ngClass.lt-md="fw">
            <form [formGroup]="registerForm" *ngIf="enviado==false">
                <div>
                    <label>Nombre y apellido <span class="red-5">*</span></label>
                    <input type="text" formControlName="nombres" class="fw">
                </div>
                <div class="mgt10">
                    <label>Empresa <span class="red-5">*</span></label>
                    <input type="text" formControlName="empresa" class="fw">
                </div>
                <div class="mgt10">
                    <label>Email <span class="red-5">*</span></label>
                    <input type="text" formControlName="email" class="fw">
                </div>
                <div class="mgt10">
                    <label>Telefono <span class="red-5">*</span></label>
                    <input type="text" formControlName="telefono" class="fw">
                </div>
                <div class="mgt10">
                    <label>País<span class="red-5">*</span></label>
                    <input type="text" formControlName="pais" class="fw">
                </div>

                <div class="mgt20">
                    <button class="grayButton" ngClass.lt-md="fw" *ngIf="habilitarEnviar==0">Enviar</button>
                    <button class="darkButton" ngClass.lt-md="fw" *ngIf="habilitarEnviar==1"
                        (click)="enviar()">Enviar</button>
                </div>
            </form>
            <div *ngIf="enviado">
                <p>Solicitud enviada. Un asesor se estará contactando contigo a la brevedad posible. </p>
            </div>
        </div>


    </div>
</section> -->